'use strict';

function LoanApplicationIncomeWeekly() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [_MoneyController];
  this._payDayOfWeekVal = null;
  this._payDate = null;
  this._payFrequency = null;
  this._currentStep = 1;

  this._$classes = {
    form: '.js--loan-application-weekly-form',
    nextBtn: '.js--next',
    prevBtn: '.js--previous',
    payDayDropdown: '.js--pay-day-of-week',
    payDateSelector: '.js--next-pay-date',
    weeklyPayFirstheader: '.js--weekly-header1',
    weeklyPaySecondheader: '.js--weekly-header2'
  };

  this._fieldsInteractedWith = [];
  this._submissionFlag = false;

  this.init = function () {
    this._super();
  };

  this.initAllReady = function () {
    this._super();
  };

  this.initPage = function () {
    this._$node = $(this.node);
    this._$nextBtn = this._$node.find(this._$classes.nextBtn);
    this._$prevBtn = this._$node.find(this._$classes.prevBtn);
    this._$form = this._$node.find(this._$classes.form);
    this._$payDayDropdown = this._$node.find(this._$classes.payDayDropdown);
    this._$payDateSelector = this._$node.find(this._$classes.payDateSelector);
    this._$weeklyPayFirstheader = this._$node.find(this._$classes.weeklyPayFirstheader);
    this._$weeklyPaySecondheader = this._$node.find(this._$classes.weeklyPaySecondheader);

    this._payFrequency = this._loanApplications[0].getPayFrequency();
    this._firstPayDate = this._loanApplications[0].getFirstPayDate();

    this._setupForm();
    this._setupComputedVariables();
    this._setupEventHandlers();
    this._removeProgressLoader();
  };

  this._removeProgressLoader = function () {
    // Progress Loader
    this._$loanApplicationFlowLoader = $('.js--progress-loader');
    this._$loanApplicationBody = $('.js--loan-application-body-content');

    // Hide page loader
    this._$loanApplicationFlowLoader.addClass('hide');
    this._$loanApplicationBody.removeClass('hide');
  };

  this._setupForm = function () {
    // Day of the week page analytics
    this._pushDayOfWeekPageAnalytics();
    this._setDayOfWeekAttr(this._payFrequency);

    if (this._payFrequency === 'weekly' && this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
      $('.js--editable-footer').removeClass('hide');
    } else {
      $('.js--default-footer').removeClass('hide');
    }

    if (this._currentStep === 1) {
      this._$weeklyPayFirstheader.removeClass('hide');
      this._$payDayDropdown.removeClass('hide');
    } else if (this._currentStep === 2) {
      this._$weeklyPaySecondheader.removeClass('hide');
      this._$payDateSelector.removeClass('hide');
    }
  };

  this._preSelectPaymentRadio = function () {
    // Pre populate radio
    if (this._firstPayDate) {
      // Get Duration between current date and first pay date from before
      var duration = moment.duration(moment().diff(this._firstPayDate)).asWeeks();
      var weeks = void 0;

      if (duration < 0) {
        weeks = Math.ceil(Math.abs(duration));
      } else {
        weeks = Math.floor(duration);
      }
      // Val refers to the pug input value within the boolean group
      if (weeks % 2 === 0) {
        this._$payDateSelector.mogo().val('date2');
      } else {
        this._$payDateSelector.mogo().val('date1');
      }
    }
  };

  this._setupComputedVariables = function () {
    this.presenter.addComputedVariable('day_of_week', ['money._loanApplicationIncome.first_pay_date'], function (dateString) {
      if (dateString) {
        var dayOfWeek = moment(dateString).format('d');
        return dayOfWeek;
      }
    });
  };

  this._setupEventHandlers = function () {
    var _this = this;

    this._$form.on('submit', function (e) {
      e.preventDefault();
      var data = _this._$form.serializeFormToObj();
      _this._payDayOfWeekVal = data.day_of_week;

      if (!_this._payDayOfWeekVal) {
        _this._$payDayDropdown.find('select').mogo().showErrorLabel();
        _this._pushFormErrorAnalytics('day_of_week'); // Not using BE to validate
        return;
      }

      // If weekly payment OR in step two of bi weekly flow, go to Loan Customization step
      if (_this._payFrequency === 'weekly' || _this._currentStep === 2) {
        $.each(_this._$nextBtn, function (index, value) {
          value.mogo().setDisabledLoadState();
        });
        // design have come up with a confusing save button
        if (_this._payFrequency === 'bi_weekly') {
          // Pre Flight check! check for empty fields
          if (!data.weekly_pay_date) {
            $.each(_this._$nextBtn, function (index, value) {
              value.mogo().removeDisabledLoadState();
            });
            _this._pushFormErrorAnalytics('next_pay_day'); // Not using BE to validate
            _this._$payDateSelector.mogo().showErrorLabel();
            return;
          }
          // Determine whether the next pay day is + 8 or + 15 days from now
          _this._nextPayDate = _this._parseNextPayDate(data.weekly_pay_date);
          _this._loanApplications[0].saveBiWeeklyPayFrequency(_this._nextPayDate);
        } else {
          // convert to current week date format
          var weeklyPayDate = moment().day(parseInt(_this._payDayOfWeekVal));
          _this._loanApplications[0].saveWeeklyPayFrequency(weeklyPayDate);
        }

        _this._loanApplications[0].submitIncome({
          success: _this._onSubmitIncomeSuccess.bind(_this),
          failure: _this._onSubmitIncomeFailure.bind(_this)
        });
      } else if (_this._currentStep === 1 && _this._payDayOfWeekVal) {
        // push submission event before going to the next page.
        _this._pushDayOfWeekFormSubmitAnalytics('bi_weekly');

        _this._$weeklyPayFirstheader.addClass('hide');
        _this._$payDayDropdown.addClass('hide');
        _this._$weeklyPaySecondheader.removeClass('hide');
        _this._$payDateSelector.removeClass('hide');

        // Next pay day analytics, at this point, payfrequency is bi weekly
        _this._resetInteractedFields();
        _this._setSubmissionFlag(false);
        _this._pushNextPayDayPageAnalytics();
        _this._setNextPayDayAttr('bi_weekly');
        _this._preSelectPaymentRadio();

        var addWeek = 0;
        if (moment().isoWeekday() >= _this._payDayOfWeekVal) {
          addWeek = 1;
        }
        var date1 = moment().day(parseInt(_this._payDayOfWeekVal)).add(addWeek, 'week').format('ddd, MMM D');
        var date2 = moment().day(parseInt(_this._payDayOfWeekVal)).add(addWeek + 1, 'week').format('ddd, MMM D');

        // TODO: need to update Radio component to allow set label text and value dynamically
        $(_this._$payDateSelector.find('.mogo-ui-radio label')[0]).text(date1); // change format for UI;
        $(_this._$payDateSelector.find('.mogo-ui-radio label')[1]).text(date2);

        // design have come up with a confusing save button
        if (_this._payFrequency === 'bi_weekly' && _this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
          $('.js--editable-footer').removeClass('hide');
          $('.js--default-footer').addClass('hide');
        }
        _this._currentStep = 2;
      }
    });

    this._$prevBtn.on('click', function (e) {
      e.preventDefault();
      // Sending Member Navigation manually because the page is faked in to two steps
      _this.analytics.forcePushEvent('generic-member-navigation', {
        memberNavigation: ['Money-Navigation-Previous-Navigation-Component']
      });

      // If Weekly, don't show date selection
      if (_this._payFrequency == 'weekly' || _this._currentStep === 1) {
        _this._history.goToUrl(_this.paths.loans.application_flow_income);
      } else {
        // Push field abandonment data
        _this._pushAbandonmentData();
        _this._resetInteractedFields();

        _this._$weeklyPaySecondheader.addClass('hide');
        _this._$payDateSelector.addClass('hide');
        _this._$weeklyPayFirstheader.removeClass('hide');
        _this._$payDayDropdown.removeClass('hide');
        _this._pushDayOfWeekPageAnalytics(); // Push day of week analytics again
        _this._setDayOfWeekAttr(_this._payFrequency);
        _this._setSubmissionFlag(false);
        _this._currentStep = 1;

        // when you go back to step 1, you can edit
        if (_this._payFrequency === 'bi_weekly' && _this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
          $('.js--editable-footer').addClass('hide');
          $('.js--default-footer').removeClass('hide');
        }
      }
    });

    // On drop down select
    this._$form.on('change', function () {
      _this._$payDayDropdown.find('select').mogo().hideErrorLabel();
      _this._$payDayDropdown.find('select').mogo().hideError();
    });

    this._$payDateSelector.on('change', function () {
      _this._$payDateSelector.mogo().hideError();
      _this._$payDateSelector.mogo().hideErrorLabel();
    });

    // Form Abandonment Event listeners
    this._onFieldInteraction(this._$payDayDropdown.find('select'));
    this._onFieldInteraction(this._$payDateSelector);
  };

  this._parseNextPayDate = function (radioValue) {
    var addWeek = 0;
    var value = '';
    // when current day of week has passed user selected day of week
    if (moment().isoWeekday() >= this._payDayOfWeekVal) {
      addWeek = 1;
    }
    if (radioValue === 'date1') {
      value = moment().day(parseInt(this._payDayOfWeekVal)).add(addWeek, 'week'); // same as label
    } else {
      value = moment().day(parseInt(this._payDayOfWeekVal)).add(addWeek + 1, 'week');
    }
    return value;
  };

  this._onSubmitIncomeSuccess = function () {
    if (this.payFrequency === 'weekly') {
      this._pushDayOfWeekFormSubmitAnalytics('weekly');
    } else {
      this._pushNextPayDayFormSubmitAnalytics('bi_weekly');
    }
    this._setSubmissionFlag(true);
    // If it's edit mode, go to the next page then create,
    // Note: _loanAppGoToNextStep resets editMode to false;
    if (this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
      $('#LoanApplicationTray').mogo()._loanAppGoToNextStep();

      $('#Notification').mogo().create({
        type: 'success',
        msg: 'Your loan payment dates have been adjusted based on your new pay frequency. Make sure you review your application carefully before submitting it.'
      });
    } else {
      $('#LoanApplicationTray').mogo()._loanAppGoToNextStep();
    }
  };

  this._onSubmitIncomeFailure = function (data, response, request) {
    if (this.isGeneralConnectionIssue(data, response)) {
      if (this._errorInitialized === false) {
        this._errorInitialized = true;

        this.invokeConnectionIssuePage(request, {
          productLabel: 'Money'
        }, null, {
          retryRequest: true
        });
      }
    } else {
      $.each(this._$nextBtn, function (index, value) {
        value.mogo().removeDisabledLoadState();
      });

      $('#Notification').mogo().create({
        type: 'custom',
        msg: '<h2><span class="icon--warning"/>Oh no...</h2>' + "We're having some technical issues. Please try again. If the problem persists, try us again in a few minutes.",
        customClass: 'loan-application-notification--warning',
        notificationDescriber: 'error'
      });

      $.each(data.errors, function (index, element) {
        console.warn('key: ' + element.key + ', ' + ('msg: ' + element.msg));
      });
    }
  };

  this.destroy = function () {
    if (this._submissionFlag === false) {
      this._pushAbandonmentData();
    }
    this._super();
  };

  // Analytics

  this._setSubmissionFlag = function (boolean) {
    if (boolean !== null) this._submissionFlag = boolean;
  };

  this._onFieldInteraction = function (domElement) {
    var elemName = domElement.attr('name');

    if (!elemName) return console.warn('Cannot find name in domElement, please pass through correct domElement');

    var elem = $('[name=\'' + elemName + '\']', this.node);
    var fieldComponent = $(elem).mogo();

    // From UI Schema Validation
    if (fieldComponent instanceof Select) {
      $(fieldComponent.containerDiv).on('enter', setInteractionField.bind(this, elem));
      $(fieldComponent.containerDiv).on('leave', setInteractionField.bind(this, elem));
      $(elem).on('focus', setInteractionField.bind(this, elem));
      $(elem).on('blur', setInteractionField.bind(this, elem));
    } else if (fieldComponent instanceof BooleanGroup) {
      for (var j = 0; j < fieldComponent.groupElements.length; j++) {
        $(fieldComponent.groupElements[j]).on('focus', setInteractionField.bind(this, elem));
        $(fieldComponent.groupElements[j]).on('blur', setInteractionField.bind(this, elem));
      }
    }

    function setInteractionField(elem, event) {
      $(elem)[0].dataset.interacted = true;
    }
  };

  this._findInteractedFields = function () {
    var fields = this._$form[0].elements;

    for (var i = 0; i < fields.length; i++) {
      if (fields[i].dataset.interacted === 'true') {
        this._fieldsInteractedWith.push(fields[i].name);
        fields[i].dataset.interacted = 'false'; // reset fields
      }
      // Boolean Group
      if (fields[i].localName === 'fieldset' && fields[i].parentElement.dataset.interacted === 'true') {
        this._fieldsInteractedWith.push($(fields[i].parentElement).attr('name'));
        fields[i].parentElement.dataset.interacted = 'false'; // reset fields
      }
    }
  };

  this._resetInteractedFields = function () {
    var fields = this._$form[0].elements;

    for (var i = 0; i < fields.length; i++) {
      if (fields[i].dataset.interacted === 'true') {
        fields[i].dataset.interacted = 'false'; // reset fields
      }
      // Boolean Group
      if (fields[i].localName === 'fieldset' && fields[i].parentElement.dataset.interacted === 'true') {
        fields[i].parentElement.dataset.interacted = 'false'; // reset fields
      }
    }

    this._fieldsInteractedWith = [];
  };

  this._pushAbandonmentData = function () {
    this._findInteractedFields();

    if (this._fieldsInteractedWith.length) {
      this.analytics.forcePushEvent('form-abandoned', {
        FormAbandoned: [this._fieldsInteractedWith.join(', ')]
      });
    }
  };

  this._pushDayOfWeekPageAnalytics = function () {
    var url = window.location.pathname + (this.presenter.getModelProperty('money._loanApplicationEdit') === true ? '/dayoftheweek-edit' : '/dayoftheweek');

    this.analytics.forcePushEvent('virtual-page-view', {
      Page: [url]
    });
    this.analytics.forcePushEvent('mogo-money-status', null, this);
  };

  this._pushNextPayDayPageAnalytics = function () {
    var url = window.location.pathname + (this.presenter.getModelProperty('money._loanApplicationEdit') === true ? '/nextpayday-edit' : '/nextpayday');

    this.analytics.forcePushEvent('virtual-page-view', {
      Page: [url]
    });
    this.analytics.forcePushEvent('mogo-money-status', null, this);
  };

  this._pushDayOfWeekFormSubmitAnalytics = function (payFrequency) {
    var formAnalyticsID = '';
    if (payFrequency === 'weekly') {
      if (this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
        formAnalyticsID = 'Money-Form Submission-Weekly Day Of The Week Edit-null-Form';
      } else {
        formAnalyticsID = 'Money-Form Submission-Weekly Day Of The Week-null-Form';
      }
    } else if (payFrequency === 'bi_weekly') {
      if (this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
        formAnalyticsID = 'Money-Form Submission-BiWeekly Day Of The Week Edit-null-Form';
      } else {
        formAnalyticsID = 'Money-Form Submission-BiWeekly Day Of The Week-null-Form';
      }
    }
    this.analytics.forcePushEvent('form-submit', {
      FormID: [formAnalyticsID]
    });
  };

  this._pushNextPayDayFormSubmitAnalytics = function (payFrequency) {
    var formAnalyticsID = '';
    if (payFrequency === 'bi_weekly') {
      if (this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
        formAnalyticsID = 'Money-Form Submission-BiWeekly Next Pay Day Edit-null-Form';
      } else {
        formAnalyticsID = 'Money-Form Submission-BiWeekly Next Pay Day-null-Form';
      }
    }
    this.analytics.forcePushEvent('form-submit', {
      FormID: [formAnalyticsID]
    });
  };

  this._pushFormErrorAnalytics = function (formId) {
    var formErrorId = null;
    if (formId) formErrorId = formId;

    this.analytics.forcePushEvent('form-errors', {
      FormErrors: [formErrorId]
    });
  };

  this._setDayOfWeekAttr = function (payFrequency) {
    var formAnalyticsID = '';
    if (payFrequency === 'weekly') {
      if (this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
        formAnalyticsID = 'Money-Weekly Day Of The Week Edit-Form attempt-null-SubmitClick';
      } else {
        formAnalyticsID = 'Money-Weekly Day Of The Week-Form attempt-null-SubmitClick';
      }
    } else if (payFrequency === 'bi_weekly') {
      if (this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
        formAnalyticsID = 'Money-BiWeekly Day Of The Week Edit-Form attempt-null-SubmitClick';
      } else {
        formAnalyticsID = 'Money-BiWeekly Day Of The Week-Form attempt-null-SubmitClick';
      }
    }
    this._$nextBtn.attr('data-analytics-id', formAnalyticsID);
  };

  this._setNextPayDayAttr = function (payFrequency) {
    var formAnalyticsID = '';
    if (payFrequency === 'bi_weekly') {
      if (this.presenter.getModelProperty('money._loanApplicationEdit') === true) {
        formAnalyticsID = 'Money-BiWeekly Next Pay Day Edit-Form attempt-null-SubmitClick';
      } else {
        formAnalyticsID = 'Money-BiWeekly Next Pay Day-Form attempt-null-SubmitClick';
      }
    }
    this._$nextBtn.attr('data-analytics-id', formAnalyticsID);
  };
}